<template>
<div class="patrolPlan">
   <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
      <patrol-plan-drawer v-if="drawerShow" :loading.sync="loading" :templateId="templateId" :templateName="templateName" @confirm="handleConfirm" @cancel="handleCancel"></patrol-plan-drawer>
   </el-drawer>
   <el-drawer title="日历详情" size="99.3%" :modal="false" :visible.sync="datailsShow" :wrapperClosable="false" direction="rtl" ref="drawer">
      <calendar-details v-if="datailsShow"></calendar-details>
    </el-drawer>
   <div class="mainContent" :style="styleObject">
      <div class="query">
         <span>
            <el-select v-model="params.status" placeholder="巡检计划状态" clearable>
               <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
              <!-- <el-date-picker v-model="timeRangeAll" unlink-panels type="daterange datetimerange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format='yyyy-MM-dd' @change="timeChange">
              </el-date-picker> -->
              <el-date-picker
                v-model="timeRangeAll"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            <el-input v-model="params.likeKey" autocomplete="off" placeholder="请输入巡检计划名称"></el-input>
            <button v-if="rolePermit('polling:plan:query')" class="primaryBtn" @click="searchTable">查询</button>
         </span>
         <button v-if="rolePermit('polling:plan:add')" class="primaryBtn" @click="addClick">新增巡检计划</button>
         <button class="primaryBtn" @click="dateClick">日历详情</button>
      </div>
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
         <el-table-column type="index" width="55" label="序号"></el-table-column>
         <el-table-column prop="planName" label="巡检模板名称"></el-table-column>
         <el-table-column prop="" label="巡检计划状态">
            <template slot-scope="scope">
               <div>{{scope.row.status==0?"未开始":scope.row.status==1?"进行中":"已结束"}}</div>
            </template>
         </el-table-column>
         <el-table-column prop="" label="巡检人">
            <template slot-scope="scope">
               <div>{{scope.row.userName}}</div>
            </template>
         </el-table-column>
         <el-table-column prop="" label="巡检日期">
            <template slot-scope="scope">
               <div>{{scope.row.checkDate}}</div>
            </template>
         </el-table-column>
         <el-table-column prop="" label="创建时间">
            <template slot-scope="scope">
               <div>{{scope.row.createTime}}</div>
            </template>
         </el-table-column>
         <el-table-column prop="" label="操作" width="170" v-if="rolePermit('polling:plan:del')">
            <template slot-scope="scope">
               <!-- <el-button  @click="editClick(scope.row)" size="small" class="edit">编辑
               </el-button> -->
               <el-button v-if="rolePermit('polling:plan:del')" @click="delClick(scope.row)" size="small" class="del">删除</el-button>
            </template>
         </el-table-column>
      </border-table>
   </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import PatrolPlanDrawer from "@/components/patrolManagement/PatrolPlanDrawer";
import CalendarDetails from "@/components/patrolManagement/CalendarDetails";
export default {
  components: {
    BorderTable,
    PatrolPlanDrawer,
    CalendarDetails
  },
  data() {
    return {
      timeRangeAll:[],
      params: {
        status: "",
        likeKey: "",
        stime:"",
        eTime:""
      },
      options: [
        {
          value: "0",
          label: "未开始"
        },
        {
          value: "1",
          label: "进行中"
        },
        {
          value: "2",
          label: "已结束"
        }
      ],
      dataList: [],
      templateId: "", //选择行的模板ID
      templateName: "", //选择行的模板名
      styleObject: {
        height: ""
      },
      tableLoading: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      handleType: "",
      drawerTitle: "",
      drawerWidth: "500px",
      timeRange:[],
      datailsShow:false,
    };
  },
  created(){
    this.makeheight()
    // this.timeRangeAll=[new Date(new Date() - 3600 * 1000 * 24*30),new Date()]
    // this.timeRange=[this.timeInit.getYMD(this.timeRangeAll[0]),this.timeInit.getYMD(this.timeRangeAll[1])] 
    // this.params.eTime='2021-05-24 10:52:20'
    this.loadTable();    
  },
  methods: {
    searchTable(){
      this.pagination.currentPage=1
      if(this.timeRangeAll!==null&&this.timeRangeAll.length){
        this.timeRange=[this.timeInit.getYMD(this.timeRangeAll[0]),this.timeInit.getYMD(this.timeRangeAll[1])]        
      }else{
        this.timeRange=[]
      }
      this.loadTable()
    },
    //查询
    loadTable() {
      let params = Object.assign({}, this.params);
      if(this.timeRange.length){
        console.log(this.timeRange);
        params.stime=this.timeRange[0]
        params.eTime=this.timeRange[1]
      }else{
        params.stime=''
        params.eTime=''
      }
      // else{
      //   this.msg.warn('请选择正确的日期范围')
      // }
      params.page = this.pagination.currentPage;
      params.pageSize = this.pagination.pageSize;
      this.dataList = [];
      this.request
        .postParamsData("/front/polling/plan/planPageList", params)
        .then(res => {
          console.log(res);
          
          if (res.code == 200) {
            this.dataList = res.data.pageData;
            this.pagination.total = res.data.total;
          } else {
            this.pagination = {
              show: true,
              currentPage: 1,
              pageSize: 10,
              total: 0
            };
          }
        })
        .catch(error => console.log(error));
    },
    //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadTable();
    },
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadTable();
    },
    //编辑
    editClick(row) {
      console.log(row);
      this.drawerShow = true;
      this.drawerTitle = "编辑巡检计划";
      this.handleType = "edit";
      this.templateId = row.id;
      this.templateName = row.name;
      this.$store.commit("saveCurrDbSource", "编辑巡检计划");
    },
    //删除
    delClick(row) {
      this.$confirm("此操作将永久删除该巡检计划, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.request
            .postParamsData("/front/polling/plan/delPlanByPlan", {
              planId: row.planId
            })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                let num = ''
               if (this.pagination.total > 1) {
                  num = (this.pagination.total - 1) % this.pagination.pageSize
                  if (num == 0) {
                    if(this.pagination.currentPage>1){
                      this.pagination.currentPage = this.pagination.currentPage - 1
                    }
                  }
               }
                this.loadTable();
              } else if (res.code == 500) {
                this.msg.warn(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //新增
    addClick(type) {
      this.drawerShow = true;
      this.drawerTitle = "新增巡检计划";
      this.handleType = "add";
      this.templateId = "";
      this.templateName = "";
      this.$store.commit("saveCurrDbSource", "新增巡检计划");
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    //确认
    handleConfirm(data) {
      //保存页面巡检计划信息
      this.request
        .post("/front/polling/plan/addPollingPlan", data)
        .then(res => {
          console.log(res);
          
          if (res.code == 200) {
            this.msg.success("保存成功");
            this.loadTable();            
          } else {
            this.msg.warn("保存失败");
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.drawerShow = false;
    },
    //取消
    handleCancel(data) {
      console.log(data);
      this.drawerShow = false;
    },
    //日历详情
    dateClick(){
      this.datailsShow=true
    },
    timeChange(time) {     
      console.log(time);
      if(time!=null&&time!=''){
        if(time.length){
          let start=this.timeInit.getYMDHMS(time[0])
          let end=this.timeInit.getYMDHMS(time[1])
          console.log(start,end);
          this.timeRange=[start,end]
        }
      }else{
        this.timeRange=[]
      }
    },
     //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.patrolPlan {
  .query {
    margin-bottom: 20px;
  }

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }
  }
}
</style><style lang="scss">
.patrolPlan {
  .query {
    .el-input {
      width:240px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }
    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }
  }
}
</style>
